import Phaser from "phaser";

export default class TitleScreen extends Phaser.Scene {
    constructor() {
        super("titlescreen");
    }

    create() {
        const titleText = this.add.text(400, 300, "pong", {
            fontSize: "48px",
            fill: "#fff"
        }).setOrigin(0.5);

        // Wait 2 seconds, then fade out over 1 second
        this.time.delayedCall(2000, () => {
            this.cameras.main.fadeOut(1000, 0, 0, 0);
        });

        // Once the fade-out is complete, start the Game scene
        this.cameras.main.on('camerafadeoutcomplete', () => {
            this.scene.start("game");
        });
    }
}
